module.exports = __webpack_public_path__ + "static/img/6.5892ac3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/eng/6.png
// module id = EjZY
// module chunks = 0